/* src/app/shared/components/dialogs/toast/toast.component.scss */
.toast-container {
  position: absolute;
  width: 100%;
  line-height: 40px;
  z-index: 9999;
}
.message-container {
  width: 400px;
  text-align: center;
  margin: 0 auto;
  padding-top: 4px;
  background-color: #fafafa;
  border-radius: 3px;
  box-shadow:
    0px 3px 3px -2px rgba(0, 0, 0, 0.2),
    0px 3px 4px 0px rgba(0, 0, 0, 0.14),
    0px 1px 8px 0px rgba(0, 0, 0, 0.12);
}
.success {
  color: #71ce71 !important;
  font-weight: 600;
}
/*# sourceMappingURL=toast.component-ETZPCDC7.css.map */
